/**
 * The village's own animals (M5-01) — a cow and a ewe, on the same four-legged
 * frame as the stag and the boar.
 *
 * They are here because the wolves have to come for *something*. A raid on a
 * village whose only losses are abstract is a weather event; a raid that kills
 * the cow the smith's prices are quoted against is a thing eight testers will
 * still be talking about in the third week. That only works if livestock go
 * through the same pipeline as everything else — the same wound tables, the
 * same bleeding, the same butchery — which is what a body plan buys.
 *
 * The two differ in exactly the way the animals do. A cow is fifteen hundred
 * pounds of placid with horns on it and a skull you would need an axe to get
 * through; a ewe is a hundred pounds of wool that has never had an idea. Neither
 * is dangerous, and the cow is not dangerous in a way that would surprise
 * anybody who has met one: hind-heavy, because what a cow presents to a problem
 * is its back end, and it will still put a horn through you if you corner it in
 * a fold.
 */
import { quadruped } from './quadruped.js';
export const COW_PLAN = quadruped({
    id: 'cow',
    name: 'cow',
    foreleg: 'foreleg',
    hindleg: 'hind leg',
    foot: 'hoof',
    // Back-heavy: it turns away from trouble rather than facing it, which is also
    // why a wolf takes one from behind and a herder gets kicked.
    foreWeight: 0.7,
    // A thick skull on a short neck. Most of what stops a cow is the throat, and
    // that is exactly what a wolf goes for.
    skull: 0.55,
    extras: [
        {
            id: 'horn.left',
            zone: 'head',
            side: 'left',
            name: 'near horn',
            hitWeight: 0.4,
            contributes: {},
            contains: ['bone'],
        },
        {
            id: 'horn.right',
            zone: 'head',
            side: 'right',
            name: 'off horn',
            hitWeight: 0.4,
            contributes: {},
            contains: ['bone'],
        },
    ],
});
export const SHEEP_PLAN = quadruped({
    id: 'sheep',
    name: 'sheep',
    foreleg: 'foreleg',
    hindleg: 'hind leg',
    foot: 'trotter',
    foreWeight: 0.8,
    skull: 0.6,
});
//# sourceMappingURL=cattle.js.map